import React, { Component } from 'react';
import Axios from 'axios';
import PaypalExpressBtn from 'react-paypal-express-checkout';

const env = 'production';
const client = {
    sandbox: 'AexiasYAS6fcRn4MYMTnBxjuodAv-y2JJNmH2II6U0TXWHPMYyG1Sy-yJEdMUbqZLDAYHWAtzNZ6C2aQ',
    production: 'AetdQ-QQ3iU2cMo5ywB9W3qaZHeJl9Dj-HROuY0UGvOOpogSK1yUSLib0WyxK6ucdkHcXf44cymUQCzc'
};
const currency = 'USD';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            donationamount: '',
            note: '',
            error: false,
            screen: 'entry',
            loading: false,
            color: '#666'
        };
    }

    changeValue = e => {
        this.setState({[e.target.id]: e.target.value});
    }

    payPalSuccess = payment => {
        this.setState({loading: true});
        console.log(payment);
        const formdata = new FormData();
        formdata.set('name', this.state.name);
        formdata.set('email', this.state.email);
        formdata.set('donationamount', this.state.donationamount);
        formdata.set('note', this.state.note);
        Axios.post('http://34.209.234.192/backend/internalapi.php', formdata).then(() => {
            this.setState({loading: false, screen: 'done'});
        });
    }

    payPalCancel = data => {
        console.log(data);
    }

    payPalError = error => {
        console.log(error);
        this.setState({error: true});
    }

    checkAmount = () => {
        let donationamount = this.state.donationamount;
        let color = '#666';
        if ((isNaN(donationamount) || +donationamount < 5 || donationamount.includes('.')) && donationamount !== '') {
            donationamount = '';
            color = 'red';
        }
        this.setState({donationamount, color});
    }

    render() {
        if (this.state.loading) {
            return <p>Loading Data...</p>
        }
        if (this.state.error) {
            return <p>Paypal is not responding.  This means there is usually a connection issue on your end or something is wrong with Paypal.  Please try again later.</p>
        }
        if (this.state.screen === 'done') {
            return (
                <>
                    <div style={{background: '#000022', height: 60, width: '100%', position: 'relative'}}>
                        <img alt="" src="http://anniversary.ulsterpb.com/bandlogo.png" style={{position: 'absolute', top: 5, left: '50%', transform: 'translateX(-50%)'}} height="50"/>
                    </div>
                    <p style={{fontSize: 14, color: '#666', marginLeft: 20}}>Thank you for your donation!  You'll be getting an email confirmation soon.  PayPal should email you a receipt as well.</p>
                </>
            );
        }
        return (
            <>
                <div style={{background: '#000022', height: 60, width: '100%', position: 'relative'}}>
                    <img alt="" src="http://donation.ulsterpb.com/bandlogo.png" style={{position: 'absolute', top: 5, left: '50%', transform: 'translateX(-50%)'}} height="50"/>
                </div>
                
                <div style={{textAlign: 'center'}}>
                    <>
                        <h1 style={{color: '#444', marginBottom: 0}}>Ulster Pipe Band Donation Page</h1>
                        <p style={{color: '#666', fontSize: 20, margin: '20px auto 2px auto'}}>First of all:  Thank you for considering a donation to the band!</p>
                        <p style={{color: '#666', fontSize: 20, margin: '2px auto 20px auto'}}>To donate, please fill out the fields below and then click the button.</p>
                        <div style={{width: 400, borderRadius: 3, border: '1px solid #bcbcbc', margin: '0 auto 10px auto', textAlign: 'left'}}>
                            <p style={{color: '#666', fontSize: 12, padding: 0, margin: '17px 0 0 17px'}}>Name</p>
                            <input id="name" style={{color: '#666', height: 30, width: 360, marginLeft: 17, outline: 'none', border: '1px solid #bcbcbc', borderRadius: 3, fontSize: 16}} value={this.state.name} onChange={this.changeValue} />

                            <p style={{color: '#666', fontSize: 12, padding: 0, margin: '17px 0 0 17px'}}>Email</p>
                            <input id="email" style={{color: '#666', height: 30, width: 360, marginLeft: 17, outline: 'none', border: '1px solid #bcbcbc', borderRadius: 3, fontSize: 16}} value={this.state.email} onChange={this.changeValue} />

                            <p style={{color: '#666', fontSize: 12, padding: 0, margin: '17px 0 0 17px'}}>Donation Amount (USD)*</p>
                            <input id="donationamount" style={{color: '#666', height: 30, width: 360, marginLeft: 17, outline: 'none', border: '1px solid #bcbcbc', borderRadius: 3, fontSize: 16}} value={this.state.donationamount} onChange={this.changeValue} onBlur={this.checkAmount} />

                            <p style={{color: '#666', fontSize: 12, padding: 0, margin: '17px 0 0 17px'}}>Leave A Note If You Like</p>
                            <input id="note" style={{color: '#666', height: 30, width: 360, marginLeft: 17, outline: 'none', border: '1px solid #bcbcbc', borderRadius: 3, fontSize: 16}} value={this.state.note} onChange={this.changeValue} />
                            {(this.state.donationamount <= 0 || this.state.name === '' || this.state.email === '') &&
                                <img alt="" src="http://34.209.234.192/paypal.png" style={{marginLeft: 14, marginTop: 17, marginBottom: 18}} />
                            }
                            {(this.state.donationamount > 0 && this.state.name !== '' && this.state.email !== '') &&
                                <div style={{textAlign: 'center', width: 366, margin: '20px auto'}}>
                                    <PaypalExpressBtn disabled={true} style={{color: 'blue', shape: 'rect', size: 'responsive'}} shipping="1" env={env} client={client} currency={currency} total={+this.state.donationamount} onError={this.payPalError} onSuccess={this.payPalSuccess} onCancel={this.payPalCancel} />
                                </div>
                            }
                        </div>
                        <p style={{color: this.state.color, fontSize: (this.state.color === '#666' ? 12 : 16)}}>*Due to fees, the minimum donation we can accept is $5.  Please donate in whole dollars.</p>
                    </>
                </div>
            </>
        );
    }
}

export default App;